import {
  GET_BUS_LIST_ERROR,
  GET_BUS_LIST_SUCCESS,
  SET_BUS_LIST_LOADING,
  GET_BUS_DETAILS_SUCCESS,
  SET_BUS_DETAILS_LOADING,
  GET_BUSES_BY_CARRIER_ID_SUCCESS,
  SET_BUSES_BY_CARRIER_ID_LOADING,
  CREATE_BUS_SUCCESS,
  UPDATE_BUS_SUCCESS,
  REMOVE_BUS_SUCCESS,
  GET_BUS_LOCATIONS_SUCCESS,
  CLEAR_BUS_LOCATIONS,
  GET_AGENDA_BUS_LOCATION_SUCCESS,
} from '../constants/ActionTypes';

const INIT_STATE = {
  buses: {
    list: null,
    pageCount: 0,
  },
  busesStoredByCarrierIds: {},
  details: null,
  busLocations: [],
  loadingList: false,
  loadingDetails: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_BUS_LIST_ERROR:
      return {
        ...state,
        buses: {
          ...state.buses,
          list: null,
          pageCount: 0,
        },
      };
    case GET_BUS_LIST_SUCCESS:
      return {
        ...state,
        buses: {
          list: action.payload.entities,
          pageCount: action.payload.pageCount,
        },
      };
    case SET_BUS_LIST_LOADING:
      return {
        ...state,
        loadingList: action.payload.isLoading,
      };
    case GET_BUS_DETAILS_SUCCESS:
      return {
        ...state,
        details: action.payload.bus,
      };
    case SET_BUS_DETAILS_LOADING:
      return {
        ...state,
        loadingDetails: action.payload.isLoading,
      };
    case GET_BUSES_BY_CARRIER_ID_SUCCESS:
      return {
        ...state,
        busesStoredByCarrierIds: {
          ...state.busesStoredByCarrierIds,
          [action.payload.carrierId]: {
            ...state.busesStoredByCarrierIds[action.payload.carrierId],
            buses: action.payload.buses || [],
          },
        },
      };
    case SET_BUSES_BY_CARRIER_ID_LOADING:
      return {
        ...state,
        busesStoredByCarrierIds: {
          ...state.busesStoredByCarrierIds,
          [action.payload.carrierId]: {
            ...state.busesStoredByCarrierIds[action.payload.carrierId],
            loading: action.payload.loading || false,
          },
        },
      };
    case CREATE_BUS_SUCCESS:
      return {
        ...state,
        buses: {
          ...state.buses,
          list: [...state.buses.list, action.payload.bus],
        },
      };
    case UPDATE_BUS_SUCCESS: {
      const { bus } = action.payload;
      return {
        ...state,
        buses: {
          ...state.buses,
          list: state.buses.list.map(
            item =>
              item.id === bus.id
                ? {
                    busCompany: bus.busCompany,
                    id: bus.id,
                    make: bus.make,
                    model: bus.model,
                    plateNumber: bus.plateNumber,
                    seats: bus.seats,
                    phoneNumber: bus.phoneNumber,
                  }
                : item,
          ),
        },
      };
    }
    case REMOVE_BUS_SUCCESS: {
      const { busId } = action.payload;

      return {
        ...state,
        buses: {
          ...state.buses,
          list: state.buses.list.filter(item => item.id !== busId),
        },
      };
    }
    case GET_BUS_LOCATIONS_SUCCESS:
      return {
        ...state,
        busLocations: action.payload.busLocations,
      };
    case GET_AGENDA_BUS_LOCATION_SUCCESS:
      return {
        ...state,
        busLocations: [action.payload.location],
      };
    case CLEAR_BUS_LOCATIONS:
      return {
        ...state,
        busLocations: [],
      };
    default:
      return state;
  }
};
